import router from '../../shared/router';
import MenuService from '../../core/components/sidebar/MenuService';
import MenuItem from '../../core/components/sidebar/MenuItem';
import DataManagement from './views/dataManagement/DataManagement';
import TableBuilder from './views/tableBuilder/TableBuilder';
import TableView from './views/table/TableView';
import FolderView from './views/folder/FolderView';
import ModuleView from './views/module/ModuleView';
import Permissions from './views/permissions/Permissions';
import HistoryTableView from './views/table/HistoryTableView';
import TableBuilderPowerApps from './views/tableBuilder/TableBuilderPowerApps';
import TableBuilderPowerBiReport from './views/tableBuilder/TableBuilderPowerBiReport';
import PowerAppsTableView from './views/table/PowerAppsTableView';
import PowerBiReportView from './views/table/PowerBiReportView';
import LoanCalculator from '../LoanCalculator/LoanCalculator.vue';

const {routes} = router.options;
const route = routes.find(r => r.name === 'app');

const tmpRoutes = [
  {
    path: 'all-modules',
    name: 'dataManagement',
    component: DataManagement,
  },
  {
    path: 'loan-calculator',
    name: 'loanCalculator',
    component: LoanCalculator,
  },
  {
    path: 'data-quality',
    name: 'dataQuality',
    component: () => import('../DataQuality/DataQuality.vue') ,
  },
  {
    path: 'data-governance',
    name: 'dataGovernance',
    component: () => import('../DataGovernance/DataGovernance.vue') ,
  },
  {
    path: 'data-catalog',
    name: 'dataCatalog',
    component: () => import('../DataCatalog/DataCatalog.vue') ,
  },
  {
    path: 'all-modules/:moduleUuid/table/:tableId',
    name: 'dataManagementTableView',
    component: TableView,
  },
  {
    path: 'all-modules/:moduleUuid/power-apps-table/:tableId',
    name: 'dataManagementPowerAppsTableView',
    component: PowerAppsTableView,
  },
  {
    path: 'all-modules/:moduleUuid/power-bi-report/:tableId',
    name: 'dataManagementPowerBiReportView',
    component: PowerBiReportView,
  },
  {
    path: 'all-modules/:moduleUuid/builder/:tableUuid',
    name: 'dataManagementBuilder.update',
    component: TableBuilder,
  },
  {
    path: 'all-modules/:moduleUuid/builder-power-apps/:tableUuid',
    name: 'dataManagementBuilderPowerApps.update',
    component: TableBuilderPowerApps,
  },
  {
    path: 'all-modules/:moduleUuid/builder-power-bi-report/:tableUuid',
    name: 'dataManagementBuilderPowerBiReport.update',
    component: TableBuilderPowerBiReport,
  },
  {
    path: 'all-modules/:moduleUuid/builder',
    name: 'dataManagementBuilder.create',
    component: TableBuilder,
  },
  {
    path: 'all-modules/:moduleUuid/builder-power-apps',
    name: 'dataManagementBuilderPowerApps.create',
    component: TableBuilderPowerApps,
  },
  {
    path: 'all-modules/:moduleUuid/builder-power-bi-report',
    name: 'dataManagementBuilderPowerBiReport.create',
    component: TableBuilderPowerBiReport,
  },
  {
    path: 'all-modules/:moduleUuid/folder/:folderUuid',
    name: 'dataManagementFolderView',
    component: FolderView,
  },
  {
    path: 'all-modules/:moduleUuid',
    name: 'dataManagementModuleView',
    component: ModuleView,
  },
  {
    path: 'all-modules/permissions/:itemId/:type',
    name: 'dataManagementPermissions',
    component: Permissions,
  },
  {
    path: 'all-modules/:moduleUuid/table/:tableId/history',
    name: 'dataManagementHistoryTableView',
    component: HistoryTableView,
  },
];

tmpRoutes.forEach((obj) => {
  route.children.push(obj);
});

router.addRoutes([route]);
MenuService.addItem(new MenuItem('DataManagement', {
  path: '/app/all-modules',
  text: 'Module Configuration',
  uuid: 'Module Configuration',
  permission: 'read',
  weight: 1,
  icon: ['fas', 'puzzle-piece'],
}));
